import ListMotivoAusenciaImpl from "components/motivoAusencias/ListMotivoAusenciasImpl";
import React from "react";
import { Col, Row } from "reactstrap";

const ViewMotivosAusencias = () => {
  return (
  <>
        
<ListMotivoAusenciaImpl></ListMotivoAusenciaImpl>
 </>
  );
};

export default ViewMotivosAusencias;